export default __webpack_public_path__ + "static/media/whylogo2.c1438def.png";